import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  FreezeRecord,
  SecurityFreezeSlice as SecurityFreezeSliceType,
} from './types';

const initialState: SecurityFreezeSliceType = {
  freezes: null,
};

const securityFreezeSlice = createAppSlice({
  name: 'securityFreeze',
  initialState,
  reducers: {
    setFreezes(state, action: PayloadAction<FreezeRecord[]>) {
      state.freezes = action.payload;
    },
  },
});

export const { setFreezes } = securityFreezeSlice.actions;
export default securityFreezeSlice.reducer;
